// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.DashboardFolder {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background-color: var(--color_neutral_200);
  border: 1px solid var(--color_neutral_200);
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 16px;
  min-height: 72px;
}
.DashboardFolder.isSelected {
  border: 1px solid var(--color_primary_500);
}
.DashboardFolder .iconWrapper {
  width: 24px;
}
.DashboardFolder .textContent p {
  font-size: 16px;
  font-weight: 700;
  text-align: left;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.DashboardFolder .textContent span {
  color: var(--color_neutral_800);
  font-size: 12px;
  font-weight: 400;
}
.DashboardFolder .optionsWrapper {
  margin-left: auto;
}
.DashboardFolder [class^=dist_componentWrapper] {
  opacity: 0;
}
.DashboardFolder:hover {
  background-color: var(--color_primary_100);
}
.DashboardFolder:hover [class^=dist_componentWrapper] {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/dashboard/dashboard-folder/dashboard-folder.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAeF;AAbE;EACE,0CAAA;AAeJ;AAZE;EACE,WAAA;AAcJ;AAVI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EDzBJ,oBAAA;EACA,aCyBwB;EDxBxB,qBCwBwB;EDvBxB,4BAAA;EACA,gBAAA;EACA,sBANoC;AC4CtC;AAdI;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AAgBN;AAZE;EACE,iBAAA;AAcJ;AAXE;EACE,UAAA;AAaJ;AAVE;EACE,0CAAA;AAYJ;AAVI;EACE,UAAA;AAYN","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins.scss';\n\n.DashboardFolder {\n  width: 100%;\n  padding: 16px;\n  border-radius: 12px;\n  background-color: var(--color_neutral_200);\n  border: 1px solid var(--color_neutral_200);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  column-gap: 16px;\n  min-height: 72px;\n\n  &.isSelected {\n    border: 1px solid var(--color_primary_500);\n  }\n\n  .iconWrapper {\n    width: 24px;\n  }\n\n  .textContent {\n    p {\n      font-size: 16px;\n      font-weight: 700;\n      text-align: left;\n      @include line-clamp(1);\n    }\n\n    span {\n      color: var(--color_neutral_800);\n      font-size: 12px;\n      font-weight: 400;\n    }\n  }\n\n  .optionsWrapper {\n    margin-left: auto;\n  }\n\n  [class^='dist_componentWrapper'] {\n    opacity: 0;\n  }\n\n  &:hover {\n    background-color: var(--color_primary_100);\n\n    [class^='dist_componentWrapper'] {\n      opacity: 1;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
